import { getInverseHistoryAction, TWebsiteBuilderEditorHistoryAction, WebsiteBuilderEditorActionType } from "./websiteBuilderEditorAction";
import { ISelectNodeAction, ISelectNodeActionPayload } from "./actions/node/selectNode";
import { IUpdateSelectedNodeAction, IUpdateSelectedNodeActionPayload } from "./actions/node/updateSelectedNode";
import { IDeleteNodeAction, IDeleteNodeActionPayload } from "./actions/node/deleteNode";
import { IMoveElementAction, IMoveElementActionPayload } from "./actions/element/moveElement";
import { IAddNodeAction, IAddNodeActionPayload } from "./actions/node/addNode";
import { IResizeElementAction, IResizeElementActionPayload } from "./actions/element/resizeElement";
import { IUpdateElementSettingsAction, IUpdateElementSettingsActionPayload } from "./actions/element/updateElementSettings";
import { IMoveSectionAction, IMoveSectionActionPayload } from "./actions/section/moveSection";
import { IResizeSectionAction, IResizeSectionActionPayload } from "./actions/section/resizeSection";
import { IBringToFrontElementAction, IBringToFrontElementActionPayload } from "./actions/element/bringToFrontElement";
import { IBringToBackElementAction, IBringToBackElementActionPayload } from "./actions/element/bringToBackElement";
import { IUpdateElementStretchAction, IUpdateElementStretchActionPayload } from "./actions/element/updateElementStretch";
import { ISelectThemeAction, ISelectThemeActionPayload } from "./actions/themes/selectThemeAction";
import { IUpdateGlobalStylesAction, IUpdateGlobalStylesActionPayload } from "./actions/globalStyles/updateGlobalStyles";
import { ArchiveWebsiteBuilderMediaItem, ArchiveWebsiteBuilderForm, DeleteWebsiteBuilderWebsiteVersionPage, GetWebsiteBuilderFonts, GetWebsiteBuilderWebsiteVersionGlobalStyles, GetWebsiteBuilderMedia, GetWebsiteBuilderStockMedia, GetWebsiteBuilderThemes, GetWebsiteBuilderWebsiteVersionPages, GetWebsiteBuilderWebsiteVersion, IPublishWebsiteBuilderWebsiteVersionPage, IRestoreWebsiteBuilderWebsiteVersionPage, PostWebsiteBuilderForm, PostWebsiteBuilderMediaItem, PostWebsiteBuilderWebsiteVersionPage, PublishWebsiteBuilderWebsiteVersion, PutWebsiteBuilderForm, PutWebsiteBuilderWebsiteVersionPage, RestoreWebsiteBuilderMediaItem, RestoreWebsiteBuilderWebsiteVersion, GetWebsiteBuilderWebsiteVersionNavigationMenuItems, PutWebsiteBuilderWebsiteVersionNavigationMenuItemPositions, IPutWebsiteBuilderWebsiteVersionNavigationMenuItem, PutWebsiteBuilderWebsiteVersionNavigationMenuItem, IPostWebsiteBuilderWebsiteVersionNavigationMenuItem, PostWebsiteBuilderWebsiteVersionNavigationMenuItem, DeleteWebsiteBuilderWebsiteVersionNavigationMenuItem, TPutWebsiteBuilderWebsiteVersionNavigationMenuItemPositionUpdates, PutWebsiteBuilderWebsiteVersionPageHome, GetWebsiteBuilderForms, RetrieveWebsiteBuilderIconAssetsByIdentities } from "api/rpc/2024-04/facilityAdmin/websiteBuilder/websiteBuilder";
import { StatusCode } from "api/protocols";
import axios, { CancelToken } from "axios";
import { IUpdateAutoSaveStatusStateAction, IUpdateAutoSaveStatusStateActionPayload } from "./actions/autoSave/updateAutoSaveStatusState";
import { AppDispatch } from "index";
import { dequeue, enqueue, showError, showSuccess } from "redux/actions/ui";
import { IExitEditorAction } from "./actions/lifecycle/exitEditor";
import { ISetModeAction, ISetModeActionPayload } from "./actions/mode/setMode";
import { TFunction } from "i18next";
import { IUpdateSectionBackgroundAction, IUpdateSectionBackgroundActionPayload } from "./actions/section/updateSectionBackground";
import { IUpdateHeaderAction, IUpdateHeaderActionPayload } from "./actions/section/updateHeader";
import { IWebsiteBuilderRoot } from "pages/secure/facility/websiteBuilder/editor/nodes/root/websiteBuilderRoot";
import { websiteBuilderGeneratePageFragment } from "pages/secure/facility/websiteBuilder/editor/website/websiteBuilderGenerateWebsite";
import { IPublishWebsiteVersionActionPayload } from "./actions/publish/publishWebsiteVersion";
import { batch } from "react-redux";
import { websiteBuilderSetWebsite } from "../config/websiteBuilderConfig";
import { IRestoreWebsiteVersionActionPayload } from "./actions/restore/restoreWebsiteVersion";
import { IWebsiteBuilderHeader, isWebsiteBuilderHeader } from "pages/secure/facility/websiteBuilder/editor/nodes/section/websiteBuilderHeader";
import { IWebsiteBuilderFooter, isWebsiteBuilderFooter } from "pages/secure/facility/websiteBuilder/editor/nodes/section/websiteBuilderFooter";
import { ISelectPageAction, ISelectPageActionPayload } from "./actions/page/selectPage";
import { IDeletePageActionPayload } from "./actions/page/deletePage";
import { IAddPageActionPayload } from "./actions/page/addPage";
import { IRenamePageActionPayload } from "./actions/page/renamePage";
import { IWebsiteBuilderIconAsset, TWebsiteBuilderWebsiteVersionNavigationMenuItem, TWebsiteBuilderWebsiteVersionPage } from "redux/reducers/models/websiteBuilder";
import { IUpdateContainerSettingsAction, IUpdateContainerSettingsActionPayload } from "./actions/container/updateContainerSettings";
import { IReorderNavigationMenuItemsActionPayload } from "./actions/navigationMenuItems/reorderNavigationMenuItems";
import { ISetHomePageActionPayload } from "./actions/page/setHomePage";
import { IUpdateNavigationMenuItemActionPayload } from "./actions/navigationMenuItems/updateNavigationMenuItem";
import { IAddNavigationMenuItemActionPayload } from "./actions/navigationMenuItems/addNavigationMenuItem";
import { IDeleteNavigationMenuItemActionPayload } from "./actions/navigationMenuItems/deleteNavigationMenuItem";
import { IUpdateContainerStretchAction, IUpdateContainerStretchActionPayload } from "./actions/container/updateContainerStretch";
import { IBringToFrontContainerAction, IBringToFrontContainerActionPayload } from "./actions/container/bringToFrontContainer";
import { IBringToBackContainerAction, IBringToBackContainerActionPayload } from "./actions/container/bringToBackContainer";
import { IResizeContainerAction, IResizeContainerActionPayload } from "./actions/container/resizeContainer";
import { IMoveContainerAction, IMoveContainerActionPayload } from "./actions/container/moveContainer";
import { ISwapFlexChildAction, ISwapFlexChildActionPayload } from "./actions/container/swapFlexChild";
import { ISwapGridCellContentAction, ISwapGridCellContentActionPayload } from "./actions/container/swapGridCellContent";
import { IAddTabAction, IAddTabActionPayload } from "./actions/tab/addTab";
import { IDeleteTabAction, IDeleteTabActionPayload } from "./actions/tab/deleteTab";
import { ISwapTabAction, ISwapTabActionPayload } from "./actions/tab/swapTab";
import { IUpdateTabSettingsAction, IUpdateTabSettingsActionPayload } from "./actions/tab/updateTabSettings";
import { ISetDeviceViewAction, ISetDeviceViewActionPayload } from "./actions/deviceView/setDeviceView";
import { TLoadEditorPayload } from "./actions/lifecycle/loadEditor";
import { websiteBuilderEnforceSchema } from "../../../../pages/secure/facility/websiteBuilder/editor/schema/websiteBuilderEnforceSchema";
import { IWebsiteBuilderMigrationFatalError } from "redux/reducers/websiteBuilder/websiteBuilderEditor";
import { websiteBuilderBuildNavigationMenuItem, websiteBuilderBuildNavigationMenuItems } from "pages/secure/facility/websiteBuilder/editor/navigationMenu/websiteBuilderBuildNavigationMenu";
import { TWebsiteBuilderDevice } from "pages/secure/facility/websiteBuilder/editor/website/shared/device";
import { TWebsiteBuilderRootCSSVariables } from "pages/secure/facility/websiteBuilder/editor/website/shared/rootCssVariables";
import { ISetHideableNodeVisibilityAction, ISetHideableNodeVisibilityActionPayload } from "./actions/visibility/setHideableNodeVisibility";
import { cloneDeep } from "lodash";
import { isWebsiteBuilderHideableNode } from "pages/secure/facility/websiteBuilder/editor/nodes/websiteBuilderHideableNode";
import { IFormBuilderForm } from "pages/secure/facility/websiteBuilder/editor/formBuilder/editor/model/formBuilderForm";
import { IAddFormActionPayload } from "./actions/form/addForm";
import { IArchiveFormActionPayload } from "./actions/form/archiveForm";
import { IUpdateFormActionPayload } from "./actions/form/updateForm";
import { IUpdateFormNameActionPayload } from "./actions/form/updateFormName";
import { formBuilderSerializeForm } from "pages/secure/facility/websiteBuilder/editor/formBuilder/transforms/serialize/formBuilderSerializeForm";
import { formBuilderBuildForm, formBuilderBuildForms } from "pages/secure/facility/websiteBuilder/editor/formBuilder/transforms/build/formBuilderBuildForms";
import { IUpdateGridDimensionsAction, IUpdateGridDimensionsActionPayload } from "./actions/container/updateGridDimensions";
import { IAddIconAssetsAction, IAddIconAssetsActionPayload } from "./actions/icon/addIconAssets";
import { websiteBuilderLoadIconAssets, WEBSITE_BUILDER_SUGGESTED_ICON_IDENTITIES } from "pages/secure/facility/websiteBuilder/editor/nodes/element/websiteBuilderIcon";

export function websiteBuilderLoadEditor(
  websiteId: number,
  websiteVersionId: number,
  viewingPastVersion: boolean,
  token: CancelToken,
  t: TFunction,
): (dispatch: AppDispatch) => Promise<void> {
  return async (dispatch: AppDispatch) => {
    dispatch({
      type: WebsiteBuilderEditorActionType.START_LOADING_EDITOR,
    });

    const [getVersionRes, getThemesRes, getFontsRes, getGlobalStylesRes, getMediaRes, getStockMediaRes, getVersionPagesRes, getVersionNavigationMenuItemsRes, getFormsRes, getSuggestedIconAssetsRes] = await Promise.all([
      GetWebsiteBuilderWebsiteVersion({ id: websiteVersionId }, false, token),
      GetWebsiteBuilderThemes(false, token),
      GetWebsiteBuilderFonts(false, token),
      GetWebsiteBuilderWebsiteVersionGlobalStyles({ website_version_id: websiteVersionId }, false, token),
      GetWebsiteBuilderMedia({ website_id: websiteId }, false, token),
      GetWebsiteBuilderStockMedia(false, token),
      GetWebsiteBuilderWebsiteVersionPages({ website_version_id: websiteVersionId }, false, token),
      GetWebsiteBuilderWebsiteVersionNavigationMenuItems({ website_version_id: websiteVersionId }, false, token),
      GetWebsiteBuilderForms({ website_id: websiteId }, false, token),
      RetrieveWebsiteBuilderIconAssetsByIdentities({
        identities: WEBSITE_BUILDER_SUGGESTED_ICON_IDENTITIES.map(identity => ({
          provider_code: identity.providerCode,
          version_code: identity.versionCode,
          variant_code: identity.variantCode,
          asset_code: identity.assetCode,
        })),
      }, false, token),
    ]);

    const version = getVersionRes.data;
    const themes = getThemesRes.data;
    const fonts = getFontsRes.data;
    const globalStyles = getGlobalStylesRes.data;
    const media = getMediaRes.data;
    const stockMedia = getStockMediaRes.data;
    const pages = getVersionPagesRes.data;
    const activePageId = pages?.find(page => page?.is_home)?.id;
    const rawNavigationMenuItems = getVersionNavigationMenuItemsRes.data;
    const rawForms = getFormsRes.data;

    const getVersionFailed = getVersionRes.status !== StatusCode.OK || version == null;
    const getThemesFailed = getThemesRes.status !== StatusCode.OK || themes == null;
    const getFontsFailed = getFontsRes.status !== StatusCode.OK || fonts == null;
    const getGlobalStylesFailed = getGlobalStylesRes.status !== StatusCode.OK || globalStyles == null;
    const getMediaFailed = getMediaRes.status !== StatusCode.OK || media == null;
    const getStockMediaFailed = getStockMediaRes.status !== StatusCode.OK || stockMedia == null;
    const getVersionPagesFailed = getVersionPagesRes.status !== StatusCode.OK || pages == null || activePageId == null;
    const getVersionNavigationMenuItemsFailed = getVersionNavigationMenuItemsRes.status !== StatusCode.OK || rawNavigationMenuItems == null;
    const getFormsFailed = getFormsRes.status !== StatusCode.OK || rawForms == null;

    if (getVersionFailed || getThemesFailed || getFontsFailed || getGlobalStylesFailed || getMediaFailed || getStockMediaFailed || getVersionPagesFailed || getVersionNavigationMenuItemsFailed || getFormsFailed) {
      if (!token.reason) {
        if (getVersionFailed) {
          dispatch(showError(typeof getVersionRes.data === "string" ? getVersionRes.data : t("Error loading version")));
        } else if (getThemesFailed) {
          dispatch(showError(typeof getThemesRes.data === "string" ? getThemesRes.data : t("Error loading themes")));
        } else if (getFontsFailed) {
          dispatch(showError(typeof getFontsRes.data === "string" ? getFontsRes.data : t("Error loading fonts")));
        } else if (getGlobalStylesFailed) {
          dispatch(showError(typeof getGlobalStylesRes.data === "string" ? getGlobalStylesRes.data : t("Error loading styles")));
        } else if (getMediaFailed) {
          dispatch(showError(typeof getMediaRes.data === "string" ? getMediaRes.data : t("Error loading media")));
        } else if (getStockMediaFailed) {
          dispatch(showError(typeof getStockMediaRes.data === "string" ? getStockMediaRes.data : t("Error loading stock media")));
        } else if (getVersionPagesFailed) {
          dispatch(showError(typeof getVersionPagesRes.data === "string" ? getVersionPagesRes.data : t("Error loading pages")));
        } else if (getVersionNavigationMenuItemsFailed) {
          dispatch(showError(typeof getVersionNavigationMenuItemsRes.data === "string" ? getVersionNavigationMenuItemsRes.data : t("Error loading navigation menu items")));
        } else if (getFormsFailed) {
          dispatch(showError(typeof getFormsRes.data === "string" ? getFormsRes.data : t("Error loading forms")));
        } else {
          dispatch(showError(t("Error loading editor")));
        }

        dispatch({
          type: WebsiteBuilderEditorActionType.LOAD_EDITOR,
          payload: {
            editorLoadingStatus: "failed",
          },
        });
      }

      return;
    }

    const enforceSchemaResult = websiteBuilderEnforceSchema({
      header: version.header,
      footer: version.footer,
      pages,
    }, t);

    if (enforceSchemaResult.type === "error") {      
      dispatch({
        type: WebsiteBuilderEditorActionType.LOAD_EDITOR,
        payload: {
          editorLoadingStatus: "failed",
        },
      });

      const fatalError: IWebsiteBuilderMigrationFatalError = {
        type: "migration",
        message: enforceSchemaResult.message,
      };

      dispatch({
        type: WebsiteBuilderEditorActionType.SET_FATAL_ERROR,
        payload: {
          fatalError,
        },
      });

      return;
    }

    const { content: { enforcedHeader, enforcedFooter, enforcedPages } } = enforceSchemaResult;
    
    const iconAssets = await websiteBuilderLoadIconAssets(token, enforcedHeader, enforcedFooter, enforcedPages);

    if (iconAssets == null) {
      if (!token.reason) {
        dispatch(showError(t("Error loading icon assets")));

        dispatch({
          type: WebsiteBuilderEditorActionType.LOAD_EDITOR,
          payload: {
            editorLoadingStatus: "failed",
          },
        });
      }

      return;
    }
    
    const suggestedIconAssets = getSuggestedIconAssetsRes.status === StatusCode.OK ? getSuggestedIconAssetsRes.data ?? [] : [];

    const theme = themes.find(t => t.id === version.theme_id);
    const availableThemes = themes.filter(t => t.id !== theme?.id);

    const navigationMenuItems = websiteBuilderBuildNavigationMenuItems(rawNavigationMenuItems);

    const forms = formBuilderBuildForms(rawForms);

    const loadEditorPayload: TLoadEditorPayload = {
      editorLoadingStatus: "succeeded",
      websiteVersion: version,
      viewingPastVersion,
      header: enforcedHeader,
      footer: enforcedFooter,
      pages: enforcedPages,
      activePageId,
      navigationMenuItems,
      theme,
      availableThemes,
      globalStyles,
      fonts,
      iconAssets,
      suggestedIconAssets,
      media,
      stockMedia,
      forms,
    };

    dispatch({
      type: WebsiteBuilderEditorActionType.LOAD_EDITOR,
      payload: loadEditorPayload,
    });
  };
}

export function websiteBuilderExitEditor(): IExitEditorAction {
  return { type: WebsiteBuilderEditorActionType.EXIT_EDITOR };
}

export function websiteBuilderUpdateAutoSaveStatusState(payload: IUpdateAutoSaveStatusStateActionPayload): IUpdateAutoSaveStatusStateAction {
  return {
    type: WebsiteBuilderEditorActionType.UPDATE_AUTO_SAVE_STATUS_STATE,
    payload,
  };
}

export function websiteBuilderSetDeviceView(payload: ISetDeviceViewActionPayload): ISetDeviceViewAction {
  return {
    type: WebsiteBuilderEditorActionType.SET_DEVICE_VIEW,
    payload,
  };
}

export function websiteBuilderSetMode(payload: ISetModeActionPayload): ISetModeAction {
  return {
    type: WebsiteBuilderEditorActionType.SET_MODE,
    payload,
  };
}

export function websiteBuilderPublishWebsiteVersion(
  header: IWebsiteBuilderHeader,
  pages: TWebsiteBuilderWebsiteVersionPage[],
  navigationMenuItems: TWebsiteBuilderWebsiteVersionNavigationMenuItem[],
  footer: IWebsiteBuilderFooter,
  websiteVersionId: number,
  websitePublishedVersionId: number,
  faviconUrl: string,
  logoUrl: string,
  facilityLongName: string,
  rootCssVariables: TWebsiteBuilderRootCSSVariables,
  forms: IFormBuilderForm[],
  iconAssets: IWebsiteBuilderIconAsset[],
  handlePublishSuccess: (domain: string, firstPublish: boolean) => void,
  t: TFunction,
): (dispatch: AppDispatch) => Promise<void> {
  return async (dispatch: AppDispatch) => {
    dispatch(enqueue());

    try {
      if (header == null) {
        dispatch(showError(t("Header not found")));
        return;
      } else if (pages == null || pages.length === 0) {
        dispatch(showError(t("Pages not found")));
        return;
      } else if (footer == null) {
        dispatch(showError(t("Footer not found")));
        return;
      }

      const cssUrl = Array.from(document.styleSheets).find(sheet => sheet.href?.includes("website."))?.href;

      if (cssUrl == null) {
        dispatch(showError(t("Error retrieving stylesheet")));
        return;
      }

      const cssFilename = new URL(cssUrl, document.location.origin)
        .pathname
        .split("/")
        .pop();

      let css: File = null;

      try {
        const res = await axios.get<Blob>(cssUrl, { responseType: "blob" });
        const blob = res.data;

        css = new File([blob], cssFilename, { type: blob.type });
      } catch {
        dispatch(showError(t("Error loading stylesheet")));
        return;
      }

      const scriptFilename = "website-scripts.js";

      let js: File = null;

      try {
        const res = await axios.get<Blob>(`/website/${scriptFilename}`, { responseType: "blob" });
        const blob = res.data;

        js = new File([blob], scriptFilename, { type: blob.type });
      } catch {
        dispatch(showError(t("Error loading javascript")));
        return;
      }

      const publishPages: IPublishWebsiteBuilderWebsiteVersionPage[] = [];

      for (const page of pages) {
        const title = page.is_home ? facilityLongName : `${page.title} | ${facilityLongName}`;

        const pageFragment = websiteBuilderGeneratePageFragment(header, page.root, footer, title, cssFilename, scriptFilename, faviconUrl, logoUrl, rootCssVariables, pages, page.id, navigationMenuItems, forms, iconAssets, t);

        const div = document.createElement("div");
        div.appendChild(pageFragment);

        const html = `<!DOCTYPE html>\n${div.innerHTML}`;

        publishPages.push({
          id: page.id,
          slug: page.slug,
          is_home: page.is_home,
          root: JSON.stringify(page.root),
          html,
        });
      }

      const publishRes = await PublishWebsiteBuilderWebsiteVersion({
        website_version_id: websiteVersionId,
        css,
        js,
        header: JSON.stringify(header),
        footer: JSON.stringify(footer),
        pages: publishPages,
      }, false);

      if (publishRes.status === StatusCode.CONFLICT) {
        dispatch(showError(t("Editor version not compatible with server. Please refresh the page.")));
        return;
      } else if (publishRes.status !== StatusCode.OK) {
        dispatch(showError(typeof publishRes.data === "string" ? publishRes.data : t("Error publishing website")));
        return;
      }

      const publishedWebsite = publishRes.data.website;

      const enforceSchemaResult = websiteBuilderEnforceSchema({
        header: publishRes.data.new_version.header,
        footer: publishRes.data.new_version.footer,
        pages: publishRes.data.pages,
      }, t);

      if (enforceSchemaResult.type === "error") {
        const fatalError: IWebsiteBuilderMigrationFatalError = {
          type: "migration",
          message: enforceSchemaResult.message,
        };

        dispatch({
          type: WebsiteBuilderEditorActionType.SET_FATAL_ERROR,
          payload: {
            fatalError,
          },
        });

        return;
      }

      const { content: { enforcedHeader, enforcedFooter, enforcedPages } } = enforceSchemaResult;

      const loadedIconAssets = await websiteBuilderLoadIconAssets(null, enforcedHeader, enforcedFooter, enforcedPages);

      if (loadedIconAssets == null) {
        dispatch(showError(t("Error loading icon assets")));
      } else {
        dispatch(websiteBuilderAddIconAssets({ iconAssets: loadedIconAssets }));
      }

      const updatedNavigationMenuItems = websiteBuilderBuildNavigationMenuItems(publishRes.data.menu_items);

      const publishPayload: IPublishWebsiteVersionActionPayload = {
        websiteVersion: publishRes.data.new_version,
        globalStyles: publishRes.data.global_styles,
        header: enforcedHeader,
        footer: enforcedFooter,
        pages: enforcedPages,
        navigationMenuItems: updatedNavigationMenuItems,
      };

      batch(() => {
        dispatch(websiteBuilderSetWebsite({
          website: publishedWebsite,
        }));

        dispatch({
          type: WebsiteBuilderEditorActionType.PUBLISH_WEBSITE_VERSION,
          payload: publishPayload,
        });
      });

      const wasNotPublished = websitePublishedVersionId == null;

      handlePublishSuccess(publishedWebsite.domain, wasNotPublished);
    } finally {
      dispatch(dequeue());
    }
  };
}

export function websiteBuilderRestoreWebsiteVersion(
  header: IWebsiteBuilderHeader,
  pages: TWebsiteBuilderWebsiteVersionPage[],
  footer: IWebsiteBuilderFooter,
  websiteVersionId: number,
  clearViewingPastVersionUrl: () => void,
  t: TFunction,
): (dispatch: AppDispatch) => Promise<void> {
  return async (dispatch: AppDispatch) => {
    dispatch(enqueue());

    try {
      if (header == null) {
        dispatch(showError(t("Header not found")));
        return;
      } else if (pages == null || pages.length === 0) {
        dispatch(showError(t("Pages not found")));
        return;
      } else if (footer == null) {
        dispatch(showError(t("Footer not found")));
        return;
      }

      const restorePages: IRestoreWebsiteBuilderWebsiteVersionPage[] = [];

      for (const page of pages) {
        restorePages.push({
          title: page.title,
          slug: page.slug,
          is_home: page.is_home,
          root: JSON.stringify(page.root),
        });
      }

      const res = await RestoreWebsiteBuilderWebsiteVersion({
        version_id: websiteVersionId,
        header: JSON.stringify(header),
        footer: JSON.stringify(footer),
        pages: restorePages,
      }, false);

      if (res.status === StatusCode.CONFLICT) {
        dispatch(showError(t("Editor version not compatible with server. Please refresh the page.")));
        return;
      } else if (res.status !== StatusCode.OK) {
        dispatch(showError(typeof res.data === "string" ? res.data : t("Error restoring website version")));
        return;
      }

      const website = res.data.website;

      const enforceSchemaResult = websiteBuilderEnforceSchema({
        header: res.data.new_version.header,
        footer: res.data.new_version.footer,
        pages: res.data.pages,
      }, t);

      if (enforceSchemaResult.type === "error") {
        const fatalError: IWebsiteBuilderMigrationFatalError = {
          type: "migration",
          message: enforceSchemaResult.message,
        };

        dispatch({
          type: WebsiteBuilderEditorActionType.SET_FATAL_ERROR,
          payload: {
            fatalError,
          },
        });

        return;
      }

      const { content: { enforcedHeader, enforcedFooter, enforcedPages } } = enforceSchemaResult;

      const loadedIconAssets = await websiteBuilderLoadIconAssets(null, enforcedHeader, enforcedFooter, enforcedPages);

      if (loadedIconAssets == null) {
        dispatch(showError(t("Error loading icon assets")));
      } else {
        dispatch(websiteBuilderAddIconAssets({ iconAssets: loadedIconAssets }));
      }

      const navigationMenuItems = websiteBuilderBuildNavigationMenuItems(res.data.menu_items);

      const restorePayload: IRestoreWebsiteVersionActionPayload = {
        websiteVersion: res.data.new_version,
        globalStyles: res.data.global_styles,
        header: enforcedHeader,
        footer: enforcedFooter,
        pages: enforcedPages,
        navigationMenuItems,
      };

      batch(() => {
        dispatch(websiteBuilderSetWebsite({
          website,
        }));

        dispatch({
          type: WebsiteBuilderEditorActionType.RESTORE_WEBSITE_VERSION,
          payload: restorePayload,
        });
      });

      dispatch(showSuccess("Successfully restored website version"));

      clearViewingPastVersionUrl();
    } finally {
      dispatch(dequeue());
    }
  };
}

export function websiteBuilderSelectPage(payload: ISelectPageActionPayload): ISelectPageAction {
  return {
    type: WebsiteBuilderEditorActionType.SELECT_PAGE,
    payload,
  };
}

export function websiteBuilderAddPage(
  website_version_id: number,
  title: string,
  slug: string,
  root: IWebsiteBuilderRoot,
  parent_id: number,
  t: TFunction,
  onSuccess?: () => void,
): (dispatch: AppDispatch) => Promise<void> {
  return async (dispatch: AppDispatch) => {
    dispatch(enqueue());

    try {
      const res = await PostWebsiteBuilderWebsiteVersionPage({
        website_version_id,
        title,
        slug,
        is_home: false,
        root: JSON.stringify(root),
        parent_id,
      }, false);

      if (res.status !== StatusCode.OK) {
        dispatch(showError(typeof res.data === "string" ? res.data : t("Error adding page")));
        return;
      }

      const enforceSchemaResult = websiteBuilderEnforceSchema({
        pages: res.data.pages,
        page: res.data.page,
      }, t);

      if (enforceSchemaResult.type === "error") {
        const fatalError: IWebsiteBuilderMigrationFatalError = {
          type: "migration",
          message: enforceSchemaResult.message,
        };

        dispatch({
          type: WebsiteBuilderEditorActionType.SET_FATAL_ERROR,
          payload: {
            fatalError,
          },
        });

        return;
      }

      const { content: { enforcedPages, enforcedPage } } = enforceSchemaResult;

      const loadedIconAssets = await websiteBuilderLoadIconAssets(null, null, null, enforcedPages);

      if (loadedIconAssets == null) {
        dispatch(showError(t("Error loading icon assets")));
      } else {
        dispatch(websiteBuilderAddIconAssets({ iconAssets: loadedIconAssets }));
      }

      const navigationMenuItems = websiteBuilderBuildNavigationMenuItems(res.data.menu_items);

      const addPagePayload: IAddPageActionPayload = {
        navigationMenuItems,
        pages: enforcedPages,
        page: enforcedPage,
      };

      dispatch({
        type: WebsiteBuilderEditorActionType.ADD_PAGE,
        payload: addPagePayload,
      });

      dispatch(showSuccess(t("Successfully added page")));

      if (onSuccess) {
        onSuccess();
      }
    } finally {
      dispatch(dequeue());
    }
  };
}

export function websiteBuilderDeletePage(id: number, t: TFunction): (dispatch: AppDispatch) => Promise<void> {
  return async (dispatch: AppDispatch) => {
    dispatch(enqueue());

    try {
      const res = await DeleteWebsiteBuilderWebsiteVersionPage({
        id,
      }, false);

      if (res.status !== StatusCode.OK) {
        dispatch(showError(typeof res.data === "string" ? res.data : t("Error deleting page")));
        return;
      }

      const enforceSchemaResult = websiteBuilderEnforceSchema({
        pages: res.data.pages,
      }, t);

      if (enforceSchemaResult.type === "error") {
        const fatalError: IWebsiteBuilderMigrationFatalError = {
          type: "migration",
          message: enforceSchemaResult.message,
        };

        dispatch({
          type: WebsiteBuilderEditorActionType.SET_FATAL_ERROR,
          payload: {
            fatalError,
          },
        });

        return;
      }

      const { content: { enforcedPages } } = enforceSchemaResult;

      const loadedIconAssets = await websiteBuilderLoadIconAssets(null, null, null, enforcedPages);

      if (loadedIconAssets == null) {
        dispatch(showError(t("Error loading icon assets")));
      } else {
        dispatch(websiteBuilderAddIconAssets({ iconAssets: loadedIconAssets }));
      }

      const navigationMenuItems = websiteBuilderBuildNavigationMenuItems(res.data.menu_items);

      const deletePagePayload: IDeletePageActionPayload = {
        navigationMenuItems,
        pages: enforcedPages,
      };

      dispatch({
        type: WebsiteBuilderEditorActionType.DELETE_PAGE,
        payload: deletePagePayload,
      });

      dispatch(showSuccess(t("Successfully deleted page")));
    } finally {
      dispatch(dequeue());
    }
  };
}

export function websiteBuilderRenamePage(
  id: number,
  title: string,
  slug: string,
  onSuccess: () => void,
  t: TFunction,
): (dispatch: AppDispatch) => Promise<void> {
  return async (dispatch: AppDispatch) => {
    dispatch(enqueue());

    try {
      const res = await PutWebsiteBuilderWebsiteVersionPage({
        id,
        title,
        slug,
      }, false, null);

      if (res.status !== StatusCode.OK) {
        dispatch(showError(typeof res.data === "string" ? res.data : t("Error renaming page")));
        return;
      }

      const enforceSchemaResult = websiteBuilderEnforceSchema({
        page: res.data,
      }, t);

      if (enforceSchemaResult.type === "error") {
        const fatalError: IWebsiteBuilderMigrationFatalError = {
          type: "migration",
          message: enforceSchemaResult.message,
        };

        dispatch({
          type: WebsiteBuilderEditorActionType.SET_FATAL_ERROR,
          payload: {
            fatalError,
          },
        });

        return;
      }

      const { content: { enforcedPage } } = enforceSchemaResult;

      const loadedIconAssets = await websiteBuilderLoadIconAssets(null, null, null, [enforcedPage]);

      if (loadedIconAssets == null) {
        dispatch(showError(t("Error loading icon assets")));
      } else {
        dispatch(websiteBuilderAddIconAssets({ iconAssets: loadedIconAssets }));
      }

      const renamePagePayload: IRenamePageActionPayload = {
        page: enforcedPage,
      };

      dispatch({
        type: WebsiteBuilderEditorActionType.RENAME_PAGE,
        payload: renamePagePayload,
      });

      dispatch(showSuccess(t("Successfully renamed page")));

      onSuccess();
    } finally {
      dispatch(dequeue());
    }
  };
}

export function websiteBuilderSetHomePage(
  id: number,
  t: TFunction,
): (dispatch: AppDispatch) => Promise<void> {
  return async (dispatch: AppDispatch) => {
    dispatch(enqueue());

    try {
      const res = await PutWebsiteBuilderWebsiteVersionPageHome({
        id,
      }, false, null);

      if (res.status !== StatusCode.OK) {
        dispatch(showError(typeof res.data === "string" ? res.data : t("Error setting home page")));
        return;
      }

      const enforceSchemaResult = websiteBuilderEnforceSchema({
        pages: res.data.pages,
      }, t);

      if (enforceSchemaResult.type === "error") {
        const fatalError: IWebsiteBuilderMigrationFatalError = {
          type: "migration",
          message: enforceSchemaResult.message,
        };

        dispatch({
          type: WebsiteBuilderEditorActionType.SET_FATAL_ERROR,
          payload: {
            fatalError,
          },
        });

        return;
      }

      const { content: { enforcedPages } } = enforceSchemaResult;

      const loadedIconAssets = await websiteBuilderLoadIconAssets(null, null, null, enforcedPages);

      if (loadedIconAssets == null) {
        dispatch(showError(t("Error loading icon assets")));
      } else {
        dispatch(websiteBuilderAddIconAssets({ iconAssets: loadedIconAssets }));
      }

      const navigationMenuItems = websiteBuilderBuildNavigationMenuItems(res.data.menu_items);

      const setHomePagePayload: ISetHomePageActionPayload = {
        navigationMenuItems,
        pages: enforcedPages,
      };

      dispatch({
        type: WebsiteBuilderEditorActionType.SET_HOME_PAGE,
        payload: setHomePagePayload,
      });

      dispatch(showSuccess(t("Successfully set home page")));
    } finally {
      dispatch(dequeue());
    }
  };
}

export function websiteBuilderReorderNavigationMenuItems(
  items: TPutWebsiteBuilderWebsiteVersionNavigationMenuItemPositionUpdates,
  t: TFunction,
): (dispatch: AppDispatch) => Promise<void> {
  return async (dispatch: AppDispatch) => {
    dispatch(enqueue());

    try {
      const res = await PutWebsiteBuilderWebsiteVersionNavigationMenuItemPositions({
        items,
      }, false, null);

      if (res.status !== StatusCode.OK) {
        dispatch(showError(typeof res.data === "string" ? res.data : t("Error reordering navigation menu items")));
        return;
      }

      const enforceSchemaResult = websiteBuilderEnforceSchema({
        pages: res.data.pages,
      }, t);

      if (enforceSchemaResult.type === "error") {
        const fatalError: IWebsiteBuilderMigrationFatalError = {
          type: "migration",
          message: enforceSchemaResult.message,
        };

        dispatch({
          type: WebsiteBuilderEditorActionType.SET_FATAL_ERROR,
          payload: {
            fatalError,
          },
        });

        return;
      }

      const { content: { enforcedPages } } = enforceSchemaResult;

      const loadedIconAssets = await websiteBuilderLoadIconAssets(null, null, null, enforcedPages);

      if (loadedIconAssets == null) {
        dispatch(showError(t("Error loading icon assets")));
      } else {
        dispatch(websiteBuilderAddIconAssets({ iconAssets: loadedIconAssets }));
      }

      const navigationMenuItems = websiteBuilderBuildNavigationMenuItems(res.data.menu_items);

      const reorderNavigationMenuItemsPayload: IReorderNavigationMenuItemsActionPayload = {
        navigationMenuItems,
        pages: enforcedPages,
      };

      dispatch({
        type: WebsiteBuilderEditorActionType.REORDER_NAVIGATION_MENU_ITEMS,
        payload: reorderNavigationMenuItemsPayload,
      });

      dispatch(showSuccess(t("Successfully reordered navigation menu items")));
    } finally {
      dispatch(dequeue());
    }
  };
}

export function websiteBuilderUpdateNavigationMenuItem(
  params: IPutWebsiteBuilderWebsiteVersionNavigationMenuItem,
  navigationMenuItems: TWebsiteBuilderWebsiteVersionNavigationMenuItem[],
  t: TFunction,
  onSuccess?: () => void,
): (dispatch: AppDispatch) => Promise<void> {
  return async (dispatch: AppDispatch) => {
    const res = await PutWebsiteBuilderWebsiteVersionNavigationMenuItem(params, true, null);

    if (res.status !== StatusCode.OK) {
      dispatch(showError(typeof res.data === "string" ? res.data : t("Error updating navigation menu item")));
      return;
    }

    const navigationMenuItem = websiteBuilderBuildNavigationMenuItem(res.data, navigationMenuItems);

    if (navigationMenuItem == null) {
      dispatch(showError(t("Updated navigation menu item is invalid")));
      return;
    }

    const updateNavigationMenuItemPayload: IUpdateNavigationMenuItemActionPayload = {
      navigationMenuItem,
    };
    
    dispatch({
      type: WebsiteBuilderEditorActionType.UPDATE_NAVIGATION_MENU_ITEM,
      payload: updateNavigationMenuItemPayload,
    });

    dispatch(showSuccess(t("Successfully updated navigation menu item")));

    if (onSuccess) {
      onSuccess();
    }
  };
}

export function websiteBuilderAddNavigationMenuItem(
  params: IPostWebsiteBuilderWebsiteVersionNavigationMenuItem,
  t: TFunction,
  onSuccess?: () => void,
): (dispatch: AppDispatch) => Promise<void> {
  return async (dispatch: AppDispatch) => {
    dispatch(enqueue());

    try {
      const res = await PostWebsiteBuilderWebsiteVersionNavigationMenuItem(params, false);

      if (res.status !== StatusCode.OK) {
        dispatch(showError(typeof res.data === "string" ? res.data : t("Error adding navigation menu item")));
        return;
      }

      const enforceSchemaResult = websiteBuilderEnforceSchema({
        pages: res.data.pages,
      }, t);

      if (enforceSchemaResult.type === "error") {
        const fatalError: IWebsiteBuilderMigrationFatalError = {
          type: "migration",
          message: enforceSchemaResult.message,
        };

        dispatch({
          type: WebsiteBuilderEditorActionType.SET_FATAL_ERROR,
          payload: {
            fatalError,
          },
        });

        return;
      }

      const { content: { enforcedPages } } = enforceSchemaResult;

      const loadedIconAssets = await websiteBuilderLoadIconAssets(null, null, null, enforcedPages);

      if (loadedIconAssets == null) {
        dispatch(showError(t("Error loading icon assets")));
      } else {
        dispatch(websiteBuilderAddIconAssets({ iconAssets: loadedIconAssets }));
      }

      const navigationMenuItems = websiteBuilderBuildNavigationMenuItems(res.data.menu_items);

      const addNavigationMenuItemPayload: IAddNavigationMenuItemActionPayload = {
        navigationMenuItems,
        pages: enforcedPages,
      };

      dispatch({
        type: WebsiteBuilderEditorActionType.ADD_NAVIGATION_MENU_ITEM,
        payload: addNavigationMenuItemPayload,
      });

      dispatch(showSuccess(t("Successfully added navigation menu item")));

      if (onSuccess) {
        onSuccess();
      }
    } finally {
      dispatch(dequeue());
    }
  };
}

export function websiteBuilderDeleteNavigationMenuItem(
  id: number,
  t: TFunction,
): (dispatch: AppDispatch) => Promise<void> {
  return async (dispatch: AppDispatch) => {
    dispatch(enqueue());

    try {
      const res = await DeleteWebsiteBuilderWebsiteVersionNavigationMenuItem({ id }, false);

      if (res.status !== StatusCode.OK) {
        dispatch(showError(typeof res.data === "string" ? res.data : t("Error deleting navigation menu item")));
        return;
      }

      const enforceSchemaResult = websiteBuilderEnforceSchema({
        pages: res.data.pages,
      }, t);

      if (enforceSchemaResult.type === "error") {
        const fatalError: IWebsiteBuilderMigrationFatalError = {
          type: "migration",
          message: enforceSchemaResult.message,
        };

        dispatch({
          type: WebsiteBuilderEditorActionType.SET_FATAL_ERROR,
          payload: {
            fatalError,
          },
        });

        return;
      }

      const { content: { enforcedPages } } = enforceSchemaResult;

      const loadedIconAssets = await websiteBuilderLoadIconAssets(null, null, null, enforcedPages);

      if (loadedIconAssets == null) {
        dispatch(showError(t("Error loading icon assets")));
      } else {
        dispatch(websiteBuilderAddIconAssets({ iconAssets: loadedIconAssets }));
      }

      const navigationMenuItems = websiteBuilderBuildNavigationMenuItems(res.data.menu_items);

      const deleteNavigationMenuItemPayload: IDeleteNavigationMenuItemActionPayload = {
        navigationMenuItems,
        pages: enforcedPages,
      };

      dispatch({
        type: WebsiteBuilderEditorActionType.DELETE_NAVIGATION_MENU_ITEM,
        payload: deleteNavigationMenuItemPayload,
      });

      dispatch(showSuccess(t("Successfully deleted navigation menu item")));
    } finally {
      dispatch(dequeue());
    }
  };
}

export function websiteBuilderSelectTheme(payload: ISelectThemeActionPayload): ISelectThemeAction {
  return {
    type: WebsiteBuilderEditorActionType.SELECT_THEME,
    payload,
  };
}

export function websiteBuilderUpdateGlobalStyles(payload: IUpdateGlobalStylesActionPayload): IUpdateGlobalStylesAction {
  return {
    type: WebsiteBuilderEditorActionType.UPDATE_GLOBAL_STYLES,
    payload,
  };
}

export function websiteBuilderAddIconAssets(payload: IAddIconAssetsActionPayload): IAddIconAssetsAction {
  return {
    type: WebsiteBuilderEditorActionType.ADD_ICON_ASSETS,
    payload,
  };
}

export function websiteBuilderPostMediaItem(website_id: number, file: File, t: TFunction): (dispatch: AppDispatch) => Promise<void> {
  return async (dispatch: AppDispatch) => {
    const res = await PostWebsiteBuilderMediaItem({ website_id, file }, true);
    
    const media = res.data;

    if (res.status !== StatusCode.OK) {
      dispatch(showError(typeof res.data === "string" ? res.data : t("Failed to upload media item")));

      return;
    }

    dispatch({
      type: WebsiteBuilderEditorActionType.POST_MEDIA_ITEM,
      payload: {
        media,
      },
    });
  };
}

export function websiteBuilderArchiveMediaItem(id: number, t: TFunction): (dispatch: AppDispatch) => Promise<void> {
  return async (dispatch: AppDispatch) => {
    const res = await ArchiveWebsiteBuilderMediaItem({ id }, true);

    const media = res.data;

    if (res.status !== StatusCode.OK) {
      dispatch(showError(typeof res.data === "string" ? res.data : t("Failed to archive media item")));

      return;
    }

    dispatch(showSuccess(t("Successfully archived media item")));

    dispatch({
      type: WebsiteBuilderEditorActionType.ARCHIVE_MEDIA_ITEM,
      payload: {
        media,
      },
    });
  };
}

export function websiteBuilderRestoreMediaItem(id: number, t: TFunction): (dispatch: AppDispatch) => Promise<void> {
  return async (dispatch: AppDispatch) => {
    const res = await RestoreWebsiteBuilderMediaItem({ id }, true);

    const media = res.data;

    if (res.status !== StatusCode.OK) {
      dispatch(showError(typeof res.data === "string" ? res.data : t("Failed to restore media item")));

      return;
    }

    dispatch(showSuccess(t("Successfully restored media item")));

    dispatch({
      type: WebsiteBuilderEditorActionType.RESTORE_MEDIA_ITEM,
      payload: {
        media,
      },
    });
  };
}

export function websiteBuilderAddForm(
  form: IFormBuilderForm,
  t: TFunction,
  onSuccess?: (id: number) => void,
): (dispatch: AppDispatch) => Promise<void> {
  return async (dispatch: AppDispatch) => {
    const rawForm = formBuilderSerializeForm(form);

    const res = await PostWebsiteBuilderForm({
      key: rawForm.key,
      website_id: rawForm.website_id,
      name: rawForm.name,
      email_notification_enabled: rawForm.email_notification_enabled,
      rows: rawForm.rows,
    }, true);

    const savedRawForm = res.data;
    const savedForm = formBuilderBuildForm(res.data);

    if (res.status !== StatusCode.OK || savedRawForm == null || savedForm == null) {
      dispatch(showError(typeof savedRawForm === "string" ? savedRawForm : t("Error saving form")));

      return;
    }

    const addFormPayload: IAddFormActionPayload = {
      form: savedForm,
    };

    dispatch({
      type: WebsiteBuilderEditorActionType.ADD_FORM,
      payload: addFormPayload,
    });

    dispatch(showSuccess(t("Successfully created form")));

    if (onSuccess) {
      onSuccess(savedForm.id);
    }
  };
}

export function websiteBuilderArchiveForm(
  id: number,
  t: TFunction,
  onSuccess: () => void,
): (dispatch: AppDispatch) => Promise<void> {
  return async (dispatch: AppDispatch) => {
    const res = await ArchiveWebsiteBuilderForm({ id }, true);

    const archivedRawForm = res.data;

    if (res.status !== StatusCode.OK || archivedRawForm == null) {
      dispatch(showError(typeof archivedRawForm === "string" ? archivedRawForm : t("Error archiving form")));

      return;
    }

    const archiveFormPayload: IArchiveFormActionPayload = {
      id: archivedRawForm.id,
    };

    dispatch({
      type: WebsiteBuilderEditorActionType.ARCHIVE_FORM,
      payload: archiveFormPayload,
    });

    dispatch(showSuccess(t("Successfully archived form")));

    onSuccess();
  };
}

export function websiteBuilderUpdateFormName(
  id: number,
  name: string,
  t: TFunction,
  onSuccess: () => void,
): (dispatch: AppDispatch) => Promise<void> {
  return async (dispatch: AppDispatch) => {
    const res = await PutWebsiteBuilderForm({
      id,
      name,
    }, true, null);

    const updatedRawForm = res.data;
    const updatedForm = formBuilderBuildForm(updatedRawForm);

    if (res.status !== StatusCode.OK || updatedRawForm == null || updatedForm == null) {
      dispatch(showError(typeof updatedRawForm === "string" ? updatedRawForm : t("Error updating form name")));

      return;
    }

    const updateFormNamePayload: IUpdateFormNameActionPayload = {
      form: updatedForm,
    };

    dispatch({
      type: WebsiteBuilderEditorActionType.UPDATE_FORM_NAME,
      payload: updateFormNamePayload,
    });

    dispatch(showSuccess(t("Successfully updated form name")));

    onSuccess();
  };
}

export function websiteBuilderUpdateForm(
  form: IFormBuilderForm,
  t: TFunction,
  onSuccess: () => void,
): (dispatch: AppDispatch) => Promise<void> {
  return async (dispatch: AppDispatch) => {
    const rawForm = formBuilderSerializeForm(form);

    const res = await PutWebsiteBuilderForm({
      id: rawForm.id,
      name: rawForm.name,
      email_notification_enabled: rawForm.email_notification_enabled,
      rows: rawForm.rows,
    }, true, null);

    const updatedRawForm = res.data;
    const updatedForm = formBuilderBuildForm(updatedRawForm);

    if (res.status !== StatusCode.OK || updatedRawForm == null || updatedForm == null) {
      dispatch(showError(typeof updatedRawForm === "string" ? updatedRawForm : t("Error updating form")));

      return;
    }

    const updateFormPayload: IUpdateFormActionPayload = {
      form: updatedForm,
    };

    dispatch({
      type: WebsiteBuilderEditorActionType.UPDATE_FORM,
      payload: updateFormPayload,
    });

    dispatch(showSuccess(t("Successfully updated form")));

    onSuccess();
  };
}

export function websiteBuilderSelectNode(payload: ISelectNodeActionPayload): ISelectNodeAction {
  return {
    type: WebsiteBuilderEditorActionType.SELECT_NODE,
    payload,
  };
}

export function websiteBuilderUpdateSelectedNode(payload: IUpdateSelectedNodeActionPayload): IUpdateSelectedNodeAction {
  return {
    type: WebsiteBuilderEditorActionType.UPDATE_SELECTED_NODE,
    payload,
  };
}

export function websiteBuilderUndo(
  history: TWebsiteBuilderEditorHistoryAction[],
  historyIndex: number,
  activePageId: number,
  deviceView: TWebsiteBuilderDevice,
): (dispatch: AppDispatch) => void {
  return (dispatch: AppDispatch) => {
    const canUndo = history.length > 0 && historyIndex >= 0;

    if (!canUndo) {
      return;
    }
  
    const actionToUndo = history[historyIndex];

    const inverseAction = getInverseHistoryAction(actionToUndo);

    if (inverseAction == null) {
      return;
    }

    const pageMismatch = activePageId !== inverseAction.pageId;
    const deviceMismatch = deviceView !== inverseAction.device;
    const scrollRequired = pageMismatch || deviceMismatch;

    if (pageMismatch) {
      dispatch({
        type: WebsiteBuilderEditorActionType.SELECT_PAGE,
        payload: {
          activePageId: inverseAction.pageId,
        },
      });
    }

    if (deviceMismatch) {
      dispatch({
        type: WebsiteBuilderEditorActionType.SET_DEVICE_VIEW,
        payload: {
          deviceView: inverseAction.device,
        },
      });
    }

    dispatch({
      type: WebsiteBuilderEditorActionType.UNDO,
      pageId: pageMismatch ? inverseAction.pageId : activePageId,
      device: deviceMismatch ? inverseAction.device : deviceView,
      scrollNodeId: scrollRequired ? inverseAction.scrollNodeId : null,
    });
  };
}

export function websiteBuilderRedo(
  history: TWebsiteBuilderEditorHistoryAction[],
  historyIndex: number,
  activePageId: number,
  deviceView: TWebsiteBuilderDevice,
): (dispatch: AppDispatch) => void {
  return (dispatch: AppDispatch) => {
    const canRedo = history.length > 0 && historyIndex < history.length - 1;

    if (!canRedo) {
      return;
    }

    const nextActionIndex = historyIndex + 1;
    const actionToRedo = history[nextActionIndex];

    const pageMismatch = activePageId !== actionToRedo.pageId;
    const deviceMismatch = deviceView !== actionToRedo.device;
    const scrollRequired = pageMismatch || deviceMismatch;

    if (pageMismatch) {
      dispatch({
        type: WebsiteBuilderEditorActionType.SELECT_PAGE,
        payload: {
          activePageId: actionToRedo.pageId,
        },
      });
    }

    if (deviceMismatch) {
      dispatch({
        type: WebsiteBuilderEditorActionType.SET_DEVICE_VIEW,
        payload: {
          deviceView: actionToRedo.device,
        },
      });
    }

    dispatch({
      type: WebsiteBuilderEditorActionType.REDO,
      pageId: pageMismatch ? actionToRedo.pageId : activePageId,
      device: deviceMismatch ? actionToRedo.device : deviceView,
      scrollNodeId: scrollRequired ? actionToRedo.scrollNodeId : null,
    });
  };
}

export function websiteBuilderAddNode(pageId: number, device: TWebsiteBuilderDevice, scrollNodeId: string, payload: IAddNodeActionPayload): IAddNodeAction {
  const snapshotNode = payload.snapshot.node;
  
  if (
    !isWebsiteBuilderHideableNode(snapshotNode) ||
    isWebsiteBuilderHeader(snapshotNode) ||
    isWebsiteBuilderFooter(snapshotNode)
  ) {
    return null;
  }

  const updatedSnapshotNode = cloneDeep(snapshotNode);

  const visibility = updatedSnapshotNode.type === "section"
    ? updatedSnapshotNode.section.visibility
    : updatedSnapshotNode.type === "container"
      ? updatedSnapshotNode.container.visibility
      : updatedSnapshotNode.element.visibility;

  if (device === "tablet") {
    visibility.desktop = false;
  }

  if (device === "mobile") {
    visibility.desktop = false;
    visibility.tablet = false;
  }

  visibility[device] = true;

  return {
    type: WebsiteBuilderEditorActionType.ADD_NODE,
    pageId,
    device,
    scrollNodeId,
    payload: {
      ...payload,
      snapshot: {
        ...payload.snapshot,
        node: updatedSnapshotNode,
      },
    },
  };
}

export function websiteBuilderDeleteNode(pageId: number, device: TWebsiteBuilderDevice, scrollNodeId: string, payload: IDeleteNodeActionPayload): IDeleteNodeAction {
  return {
    type: WebsiteBuilderEditorActionType.DELETE_NODE,
    pageId,
    device,
    scrollNodeId,
    payload,
  };
}

export function websiteBuilderSetHideableNodeVisibility(pageId: number, device: TWebsiteBuilderDevice, scrollNodeId: string, payload: ISetHideableNodeVisibilityActionPayload): ISetHideableNodeVisibilityAction {
  return {
    type: WebsiteBuilderEditorActionType.SET_HIDEABLE_NODE_VISIBILITY,
    pageId,
    device,
    scrollNodeId,
    payload,
  };
}

export function websiteBuilderMoveElement(pageId: number, device: TWebsiteBuilderDevice, scrollNodeId: string, payload: IMoveElementActionPayload): IMoveElementAction {
  return {
    type: WebsiteBuilderEditorActionType.MOVE_ELEMENT,
    pageId,
    device,
    scrollNodeId,
    payload,
  };
}

export function websiteBuilderResizeElement(pageId: number, device: TWebsiteBuilderDevice, scrollNodeId: string, payload: IResizeElementActionPayload): IResizeElementAction {
  return {
    type: WebsiteBuilderEditorActionType.RESIZE_ELEMENT,
    pageId,
    device,
    scrollNodeId,
    payload,
  };
}

export function websiteBuilderBringToFrontElement(pageId: number, device: TWebsiteBuilderDevice, scrollNodeId: string, payload: IBringToFrontElementActionPayload): IBringToFrontElementAction {
  return {
    type: WebsiteBuilderEditorActionType.BRING_TO_FRONT_ELEMENT,
    pageId,
    device,
    scrollNodeId,
    payload,
  };
}

export function websiteBuilderBringToBackElement(pageId: number, device: TWebsiteBuilderDevice, scrollNodeId: string, payload: IBringToBackElementActionPayload): IBringToBackElementAction {
  return {
    type: WebsiteBuilderEditorActionType.BRING_TO_BACK_ELEMENT,
    pageId,
    device,
    scrollNodeId,
    payload,
  };
}

export function websiteBuilderUpdateElementSettings(pageId: number, device: TWebsiteBuilderDevice, scrollNodeId: string, payload: IUpdateElementSettingsActionPayload): IUpdateElementSettingsAction {
  return {
    type: WebsiteBuilderEditorActionType.UPDATE_ELEMENT_SETTINGS,
    pageId,
    device,
    scrollNodeId,
    payload,
  };
}

export function websiteBuilderUpdateElementStretch(pageId: number, device: TWebsiteBuilderDevice, scrollNodeId: string, payload: IUpdateElementStretchActionPayload): IUpdateElementStretchAction {
  return {
    type: WebsiteBuilderEditorActionType.UPDATE_ELEMENT_STRETCH,
    pageId,
    device,
    scrollNodeId,
    payload,
  };
}

export function websiteBuilderMoveContainer(pageId: number, device: TWebsiteBuilderDevice, scrollNodeId: string, payload: IMoveContainerActionPayload): IMoveContainerAction {
  return {
    type: WebsiteBuilderEditorActionType.MOVE_CONTAINER,
    pageId,
    device,
    scrollNodeId,
    payload,
  };
}

export function websiteBuilderResizeContainer(pageId: number, device: TWebsiteBuilderDevice, scrollNodeId: string, payload: IResizeContainerActionPayload): IResizeContainerAction {
  return {
    type: WebsiteBuilderEditorActionType.RESIZE_CONTAINER,
    pageId,
    device,
    scrollNodeId,
    payload,
  };
}

export function websiteBuilderBringToFrontContainer(pageId: number, device: TWebsiteBuilderDevice, scrollNodeId: string, payload: IBringToFrontContainerActionPayload): IBringToFrontContainerAction {
  return {
    type: WebsiteBuilderEditorActionType.BRING_TO_FRONT_CONTAINER,
    pageId,
    device,
    scrollNodeId,
    payload,
  };
}

export function websiteBuilderBringToBackContainer(pageId: number, device: TWebsiteBuilderDevice, scrollNodeId: string, payload: IBringToBackContainerActionPayload): IBringToBackContainerAction {
  return {
    type: WebsiteBuilderEditorActionType.BRING_TO_BACK_CONTAINER,
    pageId,
    device,
    scrollNodeId,
    payload,
  };
}

export function websiteBuilderUpdateContainerSettings(pageId: number, device: TWebsiteBuilderDevice, scrollNodeId: string, payload: IUpdateContainerSettingsActionPayload): IUpdateContainerSettingsAction {
  return {
    type: WebsiteBuilderEditorActionType.UPDATE_CONTAINER_SETTINGS,
    pageId,
    device,
    scrollNodeId,
    payload,
  };
}

export function websiteBuilderUpdateContainerStretch(pageId: number, device: TWebsiteBuilderDevice, scrollNodeId: string, payload: IUpdateContainerStretchActionPayload): IUpdateContainerStretchAction {
  return {
    type: WebsiteBuilderEditorActionType.UPDATE_CONTAINER_STRETCH,
    pageId,
    device,
    scrollNodeId,
    payload,
  };
}

export function websiteBuilderUpdateGridDimensions(pageId: number, device: TWebsiteBuilderDevice, scrollNodeId: string, payload: IUpdateGridDimensionsActionPayload): IUpdateGridDimensionsAction {
  return {
    type: WebsiteBuilderEditorActionType.UPDATE_GRID_DIMENSIONS,
    pageId,
    device,
    scrollNodeId,
    payload,
  };
}

export function websiteBuilderSwapFlexChild(pageId: number, device: TWebsiteBuilderDevice, scrollNodeId: string, payload: ISwapFlexChildActionPayload): ISwapFlexChildAction {
  return {
    type: WebsiteBuilderEditorActionType.SWAP_FLEX_CHILD,
    pageId,
    device,
    scrollNodeId,
    payload,
  };
}

export function websiteBuilderSwapGridCellContent(pageId: number, device: TWebsiteBuilderDevice, scrollNodeId: string, payload: ISwapGridCellContentActionPayload): ISwapGridCellContentAction {
  return {
    type: WebsiteBuilderEditorActionType.SWAP_GRID_CELL_CONTENT,
    pageId,
    device,
    scrollNodeId,
    payload,
  };
}

export function websiteBuilderAddTab(pageId: number, device: TWebsiteBuilderDevice, scrollNodeId: string, payload: IAddTabActionPayload): IAddTabAction {
  return {
    type: WebsiteBuilderEditorActionType.ADD_TAB,
    pageId,
    device,
    scrollNodeId,
    payload,
  };
}

export function websiteBuilderDeleteTab(pageId: number, device: TWebsiteBuilderDevice, scrollNodeId: string, payload: IDeleteTabActionPayload): IDeleteTabAction {
  return {
    type: WebsiteBuilderEditorActionType.DELETE_TAB,
    pageId,
    device,
    scrollNodeId,
    payload,
  };
}

export function websiteBuilderSwapTab(pageId: number, device: TWebsiteBuilderDevice, scrollNodeId: string, payload: ISwapTabActionPayload): ISwapTabAction {
  return {
    type: WebsiteBuilderEditorActionType.SWAP_TAB,
    pageId,
    device,
    scrollNodeId,
    payload,
  };
}

export function websiteBuilderUpdateTabSettings(pageId: number, device: TWebsiteBuilderDevice, scrollNodeId: string, payload: IUpdateTabSettingsActionPayload): IUpdateTabSettingsAction {
  return {
    type: WebsiteBuilderEditorActionType.UPDATE_TAB_SETTINGS,
    pageId,
    device,
    scrollNodeId,
    payload,
  };
}

export function websiteBuilderMoveSection(pageId: number, device: TWebsiteBuilderDevice, scrollNodeId: string, payload: IMoveSectionActionPayload): IMoveSectionAction {
  return {
    type: WebsiteBuilderEditorActionType.MOVE_SECTION,
    pageId,
    device,
    scrollNodeId,
    payload,
  };
}

export function websiteBuilderResizeSection(pageId: number, device: TWebsiteBuilderDevice, scrollNodeId: string, payload: IResizeSectionActionPayload): IResizeSectionAction {
  return {
    type: WebsiteBuilderEditorActionType.RESIZE_SECTION,
    pageId,
    device,
    scrollNodeId,
    payload,
  };
}

export function websiteBuilderUpdateSectionBackground(pageId: number, device: TWebsiteBuilderDevice, scrollNodeId: string, payload: IUpdateSectionBackgroundActionPayload): IUpdateSectionBackgroundAction {
  return {
    type: WebsiteBuilderEditorActionType.UPDATE_SECTION_BACKGROUND,
    pageId,
    device,
    scrollNodeId,
    payload,
  };
}

export function websiteBuilderUpdateHeader(pageId: number, device: TWebsiteBuilderDevice, scrollNodeId: string, payload: IUpdateHeaderActionPayload): IUpdateHeaderAction {
  return {
    type: WebsiteBuilderEditorActionType.UPDATE_HEADER,
    pageId,
    device,
    scrollNodeId,
    payload,
  };
}